import { render } from "./FilterBase.vue?vue&type=template&id=f0a0bb66&ts=true"
import script from "./FilterBase.vue?vue&type=script&lang=ts"
export * from "./FilterBase.vue?vue&type=script&lang=ts"

import "./FilterBase.vue?vue&type=style&index=0&id=f0a0bb66&lang=scss"

import exportComponent from "/Users/camp/Desktop/code-time/acampa-gestao-pra/vuecode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__